import { combineReducers } from "redux";

import { theme } from "./theme.reducer";
import { article } from "./article.reducer";
import { auth } from "./auth.reducer";
import { url } from "./url.reducer";
import { aboutVideoReducer } from './../../Demo/Other/SocialMedia/about_us_video/productSlice'

const rootReducer = combineReducers({
  theme,
  article,
  auth,
  url,
  aboutVideo : aboutVideoReducer
});

export default rootReducer;
